export default __webpack_public_path__ + "static/media/amazon-firestick.25ea435d.jpg";